import { getAuth } from "@firebase/auth";
import { useEffect, useState } from "react";
import DeleteHolidays from "../../../../Controllers/Admin/Holidays/DeleteHolidays";
import GetAllHolidays from "../../../../Controllers/Admin/Holidays/GetAllHolidays";
import GetUser from "../../../../Controllers/Users/GetUser";
import { ToastSuccessMessages } from "../../../../Helpers/ToastMessages";

export default function HolidaysListingViewModel() {
  const [HolidaysID, setHolidaysID] = useState("");
  const [SchoolID, setSchoolID] = useState("");
  const [IsLoading, setIsLoading] = useState(true);
  const [Refresh, setRefresh] = useState(true);

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("schoolId"));
    setSchoolID(items);
  }, []);

  const [AuthUser, setAuthUser] = useState();
  const [HolidaysArray, setHolidaysArray] = useState([]);

  const HandleRefresh = () => {
    setIsLoading(true);
    setRefresh(!Refresh);
  };

  useEffect(() => {
    async function fetchData() {
      getAuth().onAuthStateChanged(async (user) => {
        const UserData = await GetUser(user?.uid);
        setAuthUser(UserData);
      });
    }
    fetchData();
  }, []);

  useEffect(() => {
    async function fetchData() {
      const HolidaysData = await GetAllHolidays(AuthUser?.uid, SchoolID);
      setHolidaysArray(HolidaysData);
      setIsLoading(false);
    }
    fetchData();
  }, [AuthUser?.uid, SchoolID, Refresh]);

  // Action Confirmation Start
  const [DeleteDialog, setDeleteDialog] = useState(false);

  const handleOpenDeleteDialog = (id) => {
    setHolidaysID(id);
    setDeleteDialog(true);
  };

  const handleCloseDeleteDialog = async (del) => {
    setDeleteDialog(false);
    if (del === true) {
      await DeleteHolidays(HolidaysID);
      ToastSuccessMessages("holiday/delete-successful");
      HandleRefresh();
      setDeleteDialog(false);
    }
  };
  // Action Confirmation End

  return {
    DeleteDialog,
    handleOpenDeleteDialog,
    handleCloseDeleteDialog,
    HolidaysArray,
    IsLoading,
  };
}
